var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOceanConservation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.15 15.61c-2.47-2.12-7.6-1.47-10.41 1.74a8.59 8.59 0 0 0-2.21-1.73c-1.15-.57-2.12-.78-2.43 2.84a13.63 13.63 0 0 0 .13 3.78 1 1 0 0 0 .71.66c1.57.35 2.72-2 3.66-3.44 1.41 2.84 5 3.85 8 3.06 3.2-.83 5.1-4.73 2.55-6.91ZM5.36 21c-.25.36-.77 1-1.21.95-.39-.55-.29-3.86-.05-4.93.29-1.32.34-1.18 1.13-.81a8.42 8.42 0 0 1 2.13 1.58Zm12.3-1a4.57 4.57 0 0 1-2.28 1.64c-2.81.81-6.17-.13-7.34-2.86a7.43 7.43 0 0 1 5.07-3.15c-2.21 3-.4 6.22.3 5.75.51-.34-.42-.49-.28-2.64a9.19 9.19 0 0 1 .87-3.21c3.66-.19 5.32 2.21 3.66 4.47Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.79 17a.72.72 0 0 0-.7.27c-.68.73.6 1.73 1.08.94.34-.51-.03-1.27-.38-1.21Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.84 14.44c.33 2.67 4.18 1.72 3.4-.85s-3.68-1.5-3.4.85Zm1.82.46c-.49.14-.79-.22-.9-.63-.33-1.27 1.24-2.11 1.54-.45a.85.85 0 0 1-.64 1.08Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9 7.73c-.43-1.45-1.78-2.58-4.15-.53a1.89 1.89 0 0 0 .38 3.07 2.41 2.41 0 0 0 3.77-2.54Zm-3.53 1.33a.91.91 0 0 1-.05-1.27c1.62-1.74 2.5-.64 2.67.17.33 1.53-1.78 2.11-2.62 1.1Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.33 2.31.89 1a4.25 4.25 0 0 0 3.14 1 4.78 4.78 0 0 0 2.77-1.17 4.83 4.83 0 0 0 .49-.4c1.53 1.59 4.3 1.77 5.52.61L19 2.13a5.93 5.93 0 0 1 .74.6c4.18 2.69 4.22.59 3.47.66-1.53.11-3.44-1.82-4.15-2.07-.37-.12-.6.06-.85.35-.49.58-.62 1.37-2 1.39A4.28 4.28 0 0 1 14 2.45c-.62-.41-.83-.89-1.11-1.07a.64.64 0 0 0-.89.12 3.65 3.65 0 0 1-1.6 1.4 3.67 3.67 0 0 1-2.4.18c-1.19-.3-1.35-.88-1.93-1.37-.11-.11-.24-.4-.34-.49a.5.5 0 0 0-.81.1C3.82 3.25 2.18 4.56.5 3.1a.29.29 0 1 0-.4.43c1.77 1.7 3.77.74 5.23-1.22Z",
    fill: "#8841B9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.68 8.68a4.31 4.31 0 0 0 2.38 1.73 4.48 4.48 0 0 0 3.14-.25A7.35 7.35 0 0 0 13 8.85l.07.05c1.17 1.19 3.89 1.74 3.86.92a.33.33 0 0 0-.35-.32 3.82 3.82 0 0 1-2.88-1.2c-.29-.33-.46-.7-.88-.67s-.79.78-1 .94a3.79 3.79 0 0 1-2.17.88 3.37 3.37 0 0 1-2.35-.68l-.82-.84c-.1-.11-.24-.4-.34-.5a.58.58 0 0 0-.92.12C4.15 9.46 2.49 10.81.85 9.36a.3.3 0 0 0-.4.44c1.79 1.68 3.74.8 5.23-1.12Z",
    fill: "#8841B9",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOceanConservation);
export default __webpack_public_path__ + "static/media/ocean-conservation.687d599ab652c80e9470a4742632fc3d.svg";
export { ForwardRef as ReactComponent };